import * as React from 'react'
import MobileBottomNav from './MobileBottomNav'
import {
  getDrupalNotificationsCount,
  getNotificationCountRedis,
} from '../../queries/notificationQuery'
import {withApollo, compose, graphql} from 'react-apollo'
import {targetPropTypes} from '../../commonPropsType'
import {getContext} from 'recompose'
import {checkObjProps} from '../../utils/genericUtils'

const MobileBottomNavWrapper = (props: any) => {
  const {drupCount} = props
  const [count, setCount] = React.useState(drupCount)

  React.useEffect(() => {
    const newCount = drupCount
    if (props.notificationCountRedis === newCount) setCount(0)
    else setCount(newCount)
  }, [drupCount, props.notificationCountRedis])

  return <MobileBottomNav {...props} count={count} />
}

export default compose(
  withApollo,
  getContext(targetPropTypes),
  graphql(getDrupalNotificationsCount, {
    options: (props: any) => ({
      variables: {empId: props.citrixId},
      notifyOnNetworkStatusChange: true,
      pollInterval: props.isWindowActive ? 1800000 : 0, // Poll only if window is active,
    }),
    props: ({data}: any) => {
      return {
        drupCount: data.notificationsCount || 0,
      }
    },
  }),
  graphql(getNotificationCountRedis, {
    options: () => ({
      notifyOnNetworkStatusChange: true,
    }),
    props: ({data}: any) => {
      return {
        notificationCountRedis: checkObjProps(
          data,
          ['getNotificationCount', 'notificationCount'],
          0
        ),
      }
    },
  })
)(MobileBottomNavWrapper)
